var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-image-field"},[(_vm.saving)?_c('p',[_vm._v("Uploading .........................")]):_vm._e(),(!_vm.isUploaded && !_vm.saving)?_c('input',{ref:"file",attrs:{"id":_vm.id,"type":"file"},on:{"change":_vm.handleImageUpload}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }